
// @ts-nocheck


export const localeCodes =  [
  "en",
  "de",
  "fr",
  "nl",
  "pl",
  "ro",
  "hu",
  "en-GB",
  "de-DE",
  "nl-NL",
  "fr-FR",
  "pl-PL",
  "ro-RO",
  "hu-HU",
  "de-DE-sfp",
  "en-GB-sfp",
  "de-DE-lms",
  "en-GB-lms"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46js_740ec5b1",
      load: () => import("#nuxt-i18n/740ec5b1" /* webpackChunkName: "locale_en_46js_740ec5b1" */),
      cache: false
    }
  ],
  de: [
    {
      key: "locale_de_46js_9fc6d173",
      load: () => import("#nuxt-i18n/9fc6d173" /* webpackChunkName: "locale_de_46js_9fc6d173" */),
      cache: false
    }
  ],
  fr: [
    {
      key: "locale_de_46js_9fc6d173",
      load: () => import("#nuxt-i18n/9fc6d173" /* webpackChunkName: "locale_de_46js_9fc6d173" */),
      cache: false
    },
    {
      key: "locale_fr_46js_c960143f",
      load: () => import("#nuxt-i18n/c960143f" /* webpackChunkName: "locale_fr_46js_c960143f" */),
      cache: false
    }
  ],
  nl: [
    {
      key: "locale_de_46js_9fc6d173",
      load: () => import("#nuxt-i18n/9fc6d173" /* webpackChunkName: "locale_de_46js_9fc6d173" */),
      cache: false
    },
    {
      key: "locale_nl_46js_cba6235f",
      load: () => import("#nuxt-i18n/cba6235f" /* webpackChunkName: "locale_nl_46js_cba6235f" */),
      cache: false
    }
  ],
  pl: [
    {
      key: "locale_de_46js_9fc6d173",
      load: () => import("#nuxt-i18n/9fc6d173" /* webpackChunkName: "locale_de_46js_9fc6d173" */),
      cache: false
    },
    {
      key: "locale_pl_46js_3757d895",
      load: () => import("#nuxt-i18n/3757d895" /* webpackChunkName: "locale_pl_46js_3757d895" */),
      cache: false
    }
  ],
  ro: [
    {
      key: "locale_de_46js_9fc6d173",
      load: () => import("#nuxt-i18n/9fc6d173" /* webpackChunkName: "locale_de_46js_9fc6d173" */),
      cache: false
    },
    {
      key: "locale_ro_46js_6b94249c",
      load: () => import("#nuxt-i18n/6b94249c" /* webpackChunkName: "locale_ro_46js_6b94249c" */),
      cache: false
    }
  ],
  hu: [
    {
      key: "locale_de_46js_9fc6d173",
      load: () => import("#nuxt-i18n/9fc6d173" /* webpackChunkName: "locale_de_46js_9fc6d173" */),
      cache: false
    },
    {
      key: "locale_hu_46js_0ec6cdea",
      load: () => import("#nuxt-i18n/0ec6cdea" /* webpackChunkName: "locale_hu_46js_0ec6cdea" */),
      cache: false
    }
  ],
  "en-GB": [
    {
      key: "locale_en_46js_740ec5b1",
      load: () => import("#nuxt-i18n/740ec5b1" /* webpackChunkName: "locale_en_46js_740ec5b1" */),
      cache: false
    }
  ],
  "de-DE": [
    {
      key: "locale_de_46js_9fc6d173",
      load: () => import("#nuxt-i18n/9fc6d173" /* webpackChunkName: "locale_de_46js_9fc6d173" */),
      cache: false
    }
  ],
  "nl-NL": [
    {
      key: "locale_de_46js_9fc6d173",
      load: () => import("#nuxt-i18n/9fc6d173" /* webpackChunkName: "locale_de_46js_9fc6d173" */),
      cache: false
    },
    {
      key: "locale_nl_46js_cba6235f",
      load: () => import("#nuxt-i18n/cba6235f" /* webpackChunkName: "locale_nl_46js_cba6235f" */),
      cache: false
    }
  ],
  "fr-FR": [
    {
      key: "locale_de_46js_9fc6d173",
      load: () => import("#nuxt-i18n/9fc6d173" /* webpackChunkName: "locale_de_46js_9fc6d173" */),
      cache: false
    },
    {
      key: "locale_fr_46js_c960143f",
      load: () => import("#nuxt-i18n/c960143f" /* webpackChunkName: "locale_fr_46js_c960143f" */),
      cache: false
    }
  ],
  "pl-PL": [
    {
      key: "locale_de_46js_9fc6d173",
      load: () => import("#nuxt-i18n/9fc6d173" /* webpackChunkName: "locale_de_46js_9fc6d173" */),
      cache: false
    },
    {
      key: "locale_pl_46js_3757d895",
      load: () => import("#nuxt-i18n/3757d895" /* webpackChunkName: "locale_pl_46js_3757d895" */),
      cache: false
    }
  ],
  "ro-RO": [
    {
      key: "locale_de_46js_9fc6d173",
      load: () => import("#nuxt-i18n/9fc6d173" /* webpackChunkName: "locale_de_46js_9fc6d173" */),
      cache: false
    },
    {
      key: "locale_ro_46js_6b94249c",
      load: () => import("#nuxt-i18n/6b94249c" /* webpackChunkName: "locale_ro_46js_6b94249c" */),
      cache: false
    }
  ],
  "hu-HU": [
    {
      key: "locale_de_46js_9fc6d173",
      load: () => import("#nuxt-i18n/9fc6d173" /* webpackChunkName: "locale_de_46js_9fc6d173" */),
      cache: false
    },
    {
      key: "locale_hu_46js_0ec6cdea",
      load: () => import("#nuxt-i18n/0ec6cdea" /* webpackChunkName: "locale_hu_46js_0ec6cdea" */),
      cache: false
    }
  ],
  "de-DE-sfp": [
    {
      key: "locale_de_46js_9fc6d173",
      load: () => import("#nuxt-i18n/9fc6d173" /* webpackChunkName: "locale_de_46js_9fc6d173" */),
      cache: false
    }
  ],
  "en-GB-sfp": [
    {
      key: "locale_en_46js_740ec5b1",
      load: () => import("#nuxt-i18n/740ec5b1" /* webpackChunkName: "locale_en_46js_740ec5b1" */),
      cache: false
    }
  ],
  "de-DE-lms": [
    {
      key: "locale_de_46js_9fc6d173",
      load: () => import("#nuxt-i18n/9fc6d173" /* webpackChunkName: "locale_de_46js_9fc6d173" */),
      cache: false
    }
  ],
  "en-GB-lms": [
    {
      key: "locale_en_46js_740ec5b1",
      load: () => import("#nuxt-i18n/740ec5b1" /* webpackChunkName: "locale_en_46js_740ec5b1" */),
      cache: false
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/299f67f5" /* webpackChunkName: "config_i18n_46config_46ts_299f67f5" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      domains: [
        "my.skillsforwork.de",
        "preprod.my.skillsforwork.de",
        "dev.my.skillsforwork.de",
        "localhost:3000",
        "my.skillsforwork.com",
        "preprod.my.skillsforwork.com",
        "dev.my.skillsforwork.com"
      ],
      files: [
        {
          path: "/var/www/html/i18n/locales/en/en.js",
          cache: undefined
        }
      ]
    },
    {
      code: "de",
      domains: [
        "my.skillsforwork.de",
        "preprod.my.skillsforwork.de",
        "dev.my.skillsforwork.de",
        "localhost:3000"
      ],
      files: [
        {
          path: "/var/www/html/i18n/locales/de/de.js",
          cache: undefined
        }
      ]
    },
    {
      code: "fr",
      files: [
        {
          path: "/var/www/html/i18n/locales/de/de.js",
          cache: undefined
        },
        {
          path: "/var/www/html/i18n/locales/fr/fr.js",
          cache: undefined
        }
      ],
      domains: [
        "my.skillsforwork.de",
        "preprod.my.skillsforwork.de",
        "dev.my.skillsforwork.de",
        "localhost:3000"
      ]
    },
    {
      code: "nl",
      files: [
        {
          path: "/var/www/html/i18n/locales/de/de.js",
          cache: undefined
        },
        {
          path: "/var/www/html/i18n/locales/nl/nl.js",
          cache: undefined
        }
      ],
      domains: [
        "my.skillsforwork.de",
        "preprod.my.skillsforwork.de",
        "dev.my.skillsforwork.de",
        "localhost:3000"
      ]
    },
    {
      code: "pl",
      files: [
        {
          path: "/var/www/html/i18n/locales/de/de.js",
          cache: undefined
        },
        {
          path: "/var/www/html/i18n/locales/pl/pl.js",
          cache: undefined
        }
      ],
      domains: [
        "my.skillsforwork.de",
        "preprod.my.skillsforwork.de",
        "dev.my.skillsforwork.de",
        "localhost:3000"
      ]
    },
    {
      code: "ro",
      files: [
        {
          path: "/var/www/html/i18n/locales/de/de.js",
          cache: undefined
        },
        {
          path: "/var/www/html/i18n/locales/ro/ro.js",
          cache: undefined
        }
      ],
      domains: [
        "my.skillsforwork.de",
        "preprod.my.skillsforwork.de",
        "dev.my.skillsforwork.de",
        "localhost:3000"
      ]
    },
    {
      code: "hu",
      files: [
        {
          path: "/var/www/html/i18n/locales/de/de.js",
          cache: undefined
        },
        {
          path: "/var/www/html/i18n/locales/hu/hu.js",
          cache: undefined
        }
      ],
      domains: [
        "my.skillsforwork.de",
        "preprod.my.skillsforwork.de",
        "dev.my.skillsforwork.de",
        "localhost:3000"
      ]
    },
    {
      code: "en-GB",
      language: "en-GB",
      name: "English (UK)",
      files: [
        {
          path: "/var/www/html/i18n/locales/en/en.js",
          cache: undefined
        }
      ],
      domains: [
        "my.skillsforwork.de",
        "preprod.my.skillsforwork.de",
        "dev.my.skillsforwork.de",
        "localhost:3000",
        "my.skillsforwork.com",
        "preprod.my.skillsforwork.com",
        "dev.my.skillsforwork.com"
      ],
      defaultForDomains: [
        "my.skillsforwork.com",
        "preprod.my.skillsforwork.com",
        "dev.my.skillsforwork.com"
      ]
    },
    {
      code: "de-DE",
      language: "de-DE",
      name: "Deutsch",
      files: [
        {
          path: "/var/www/html/i18n/locales/de/de.js",
          cache: undefined
        }
      ],
      domains: [
        "my.skillsforwork.de",
        "preprod.my.skillsforwork.de",
        "dev.my.skillsforwork.de",
        "localhost:3000"
      ],
      defaultForDomains: [
        "my.skillsforwork.de",
        "preprod.my.skillsforwork.de",
        "dev.my.skillsforwork.de",
        "localhost:3000"
      ]
    },
    {
      code: "nl-NL",
      language: "nl-NL",
      name: "Nederlands",
      files: [
        {
          path: "/var/www/html/i18n/locales/de/de.js",
          cache: undefined
        },
        {
          path: "/var/www/html/i18n/locales/nl/nl.js",
          cache: undefined
        }
      ],
      domains: [
        "my.skillsforwork.de",
        "preprod.my.skillsforwork.de",
        "dev.my.skillsforwork.de",
        "localhost:3000"
      ]
    },
    {
      code: "fr-FR",
      language: "fr-FR",
      name: "Français",
      files: [
        {
          path: "/var/www/html/i18n/locales/de/de.js",
          cache: undefined
        },
        {
          path: "/var/www/html/i18n/locales/fr/fr.js",
          cache: undefined
        }
      ],
      domains: [
        "my.skillsforwork.de",
        "preprod.my.skillsforwork.de",
        "dev.my.skillsforwork.de",
        "localhost:3000"
      ]
    },
    {
      code: "pl-PL",
      language: "pl-PL",
      name: "Polski",
      files: [
        {
          path: "/var/www/html/i18n/locales/de/de.js",
          cache: undefined
        },
        {
          path: "/var/www/html/i18n/locales/pl/pl.js",
          cache: undefined
        }
      ],
      domains: [
        "my.skillsforwork.de",
        "preprod.my.skillsforwork.de",
        "dev.my.skillsforwork.de",
        "localhost:3000"
      ]
    },
    {
      code: "ro-RO",
      language: "ro-RO",
      name: "Română",
      files: [
        {
          path: "/var/www/html/i18n/locales/de/de.js",
          cache: undefined
        },
        {
          path: "/var/www/html/i18n/locales/ro/ro.js",
          cache: undefined
        }
      ],
      domains: [
        "my.skillsforwork.de",
        "preprod.my.skillsforwork.de",
        "dev.my.skillsforwork.de",
        "localhost:3000"
      ]
    },
    {
      code: "hu-HU",
      language: "hu-HU",
      name: "Magyar",
      files: [
        {
          path: "/var/www/html/i18n/locales/de/de.js",
          cache: undefined
        },
        {
          path: "/var/www/html/i18n/locales/hu/hu.js",
          cache: undefined
        }
      ],
      domains: [
        "my.skillsforwork.de",
        "preprod.my.skillsforwork.de",
        "dev.my.skillsforwork.de",
        "localhost:3000"
      ]
    },
    {
      code: "de-DE-sfp",
      name: "Deutsch (Produktspezifisch sfp)",
      files: [
        {
          path: "/var/www/html/i18n/locales/de/de.js",
          cache: undefined
        }
      ],
      domains: [
        "my.skillsforwork.de",
        "preprod.my.skillsforwork.de",
        "dev.my.skillsforwork.de",
        "localhost:3000"
      ]
    },
    {
      code: "en-GB-sfp",
      name: "English (Produktspezifisch sfp)",
      files: [
        {
          path: "/var/www/html/i18n/locales/en/en.js",
          cache: undefined
        }
      ],
      domains: [
        "my.skillsforwork.de",
        "preprod.my.skillsforwork.de",
        "dev.my.skillsforwork.de",
        "localhost:3000",
        "my.skillsforwork.com",
        "preprod.my.skillsforwork.com",
        "dev.my.skillsforwork.com"
      ]
    },
    {
      code: "de-DE-lms",
      name: "Deutsch (Produktspezifisch lms)",
      files: [
        {
          path: "/var/www/html/i18n/locales/de/de.js",
          cache: undefined
        }
      ],
      domains: [
        "my.skillsforwork.de",
        "preprod.my.skillsforwork.de",
        "dev.my.skillsforwork.de",
        "localhost:3000"
      ]
    },
    {
      code: "en-GB-lms",
      name: "English (Produktspezifisch lms)",
      files: [
        {
          path: "/var/www/html/i18n/locales/en/en.js",
          cache: undefined
        }
      ],
      domains: [
        "my.skillsforwork.de",
        "preprod.my.skillsforwork.de",
        "dev.my.skillsforwork.de",
        "localhost:3000",
        "my.skillsforwork.com",
        "preprod.my.skillsforwork.com",
        "dev.my.skillsforwork.com"
      ]
    }
  ],
  defaultLocale: "de",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: true,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "de",
    redirectOn: "root",
    useCookie: true,
    detectLocale: false
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    domains: [
      "my.skillsforwork.de",
      "preprod.my.skillsforwork.de",
      "dev.my.skillsforwork.de",
      "localhost:3000",
      "my.skillsforwork.com",
      "preprod.my.skillsforwork.com",
      "dev.my.skillsforwork.com"
    ],
    files: [
      {
        path: "/var/www/html/i18n/locales/en/en.js",
        cache: undefined
      }
    ]
  },
  {
    code: "de",
    domains: [
      "my.skillsforwork.de",
      "preprod.my.skillsforwork.de",
      "dev.my.skillsforwork.de",
      "localhost:3000"
    ],
    files: [
      {
        path: "/var/www/html/i18n/locales/de/de.js",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    files: [
      {
        path: "/var/www/html/i18n/locales/de/de.js",
        cache: undefined
      },
      {
        path: "/var/www/html/i18n/locales/fr/fr.js",
        cache: undefined
      }
    ],
    domains: [
      "my.skillsforwork.de",
      "preprod.my.skillsforwork.de",
      "dev.my.skillsforwork.de",
      "localhost:3000"
    ]
  },
  {
    code: "nl",
    files: [
      {
        path: "/var/www/html/i18n/locales/de/de.js",
        cache: undefined
      },
      {
        path: "/var/www/html/i18n/locales/nl/nl.js",
        cache: undefined
      }
    ],
    domains: [
      "my.skillsforwork.de",
      "preprod.my.skillsforwork.de",
      "dev.my.skillsforwork.de",
      "localhost:3000"
    ]
  },
  {
    code: "pl",
    files: [
      {
        path: "/var/www/html/i18n/locales/de/de.js",
        cache: undefined
      },
      {
        path: "/var/www/html/i18n/locales/pl/pl.js",
        cache: undefined
      }
    ],
    domains: [
      "my.skillsforwork.de",
      "preprod.my.skillsforwork.de",
      "dev.my.skillsforwork.de",
      "localhost:3000"
    ]
  },
  {
    code: "ro",
    files: [
      {
        path: "/var/www/html/i18n/locales/de/de.js",
        cache: undefined
      },
      {
        path: "/var/www/html/i18n/locales/ro/ro.js",
        cache: undefined
      }
    ],
    domains: [
      "my.skillsforwork.de",
      "preprod.my.skillsforwork.de",
      "dev.my.skillsforwork.de",
      "localhost:3000"
    ]
  },
  {
    code: "hu",
    files: [
      {
        path: "/var/www/html/i18n/locales/de/de.js",
        cache: undefined
      },
      {
        path: "/var/www/html/i18n/locales/hu/hu.js",
        cache: undefined
      }
    ],
    domains: [
      "my.skillsforwork.de",
      "preprod.my.skillsforwork.de",
      "dev.my.skillsforwork.de",
      "localhost:3000"
    ]
  },
  {
    code: "en-GB",
    language: "en-GB",
    name: "English (UK)",
    files: [
      {
        path: "/var/www/html/i18n/locales/en/en.js",
        cache: undefined
      }
    ],
    domains: [
      "my.skillsforwork.de",
      "preprod.my.skillsforwork.de",
      "dev.my.skillsforwork.de",
      "localhost:3000",
      "my.skillsforwork.com",
      "preprod.my.skillsforwork.com",
      "dev.my.skillsforwork.com"
    ],
    defaultForDomains: [
      "my.skillsforwork.com",
      "preprod.my.skillsforwork.com",
      "dev.my.skillsforwork.com"
    ]
  },
  {
    code: "de-DE",
    language: "de-DE",
    name: "Deutsch",
    files: [
      {
        path: "/var/www/html/i18n/locales/de/de.js",
        cache: undefined
      }
    ],
    domains: [
      "my.skillsforwork.de",
      "preprod.my.skillsforwork.de",
      "dev.my.skillsforwork.de",
      "localhost:3000"
    ],
    defaultForDomains: [
      "my.skillsforwork.de",
      "preprod.my.skillsforwork.de",
      "dev.my.skillsforwork.de",
      "localhost:3000"
    ]
  },
  {
    code: "nl-NL",
    language: "nl-NL",
    name: "Nederlands",
    files: [
      {
        path: "/var/www/html/i18n/locales/de/de.js",
        cache: undefined
      },
      {
        path: "/var/www/html/i18n/locales/nl/nl.js",
        cache: undefined
      }
    ],
    domains: [
      "my.skillsforwork.de",
      "preprod.my.skillsforwork.de",
      "dev.my.skillsforwork.de",
      "localhost:3000"
    ]
  },
  {
    code: "fr-FR",
    language: "fr-FR",
    name: "Français",
    files: [
      {
        path: "/var/www/html/i18n/locales/de/de.js",
        cache: undefined
      },
      {
        path: "/var/www/html/i18n/locales/fr/fr.js",
        cache: undefined
      }
    ],
    domains: [
      "my.skillsforwork.de",
      "preprod.my.skillsforwork.de",
      "dev.my.skillsforwork.de",
      "localhost:3000"
    ]
  },
  {
    code: "pl-PL",
    language: "pl-PL",
    name: "Polski",
    files: [
      {
        path: "/var/www/html/i18n/locales/de/de.js",
        cache: undefined
      },
      {
        path: "/var/www/html/i18n/locales/pl/pl.js",
        cache: undefined
      }
    ],
    domains: [
      "my.skillsforwork.de",
      "preprod.my.skillsforwork.de",
      "dev.my.skillsforwork.de",
      "localhost:3000"
    ]
  },
  {
    code: "ro-RO",
    language: "ro-RO",
    name: "Română",
    files: [
      {
        path: "/var/www/html/i18n/locales/de/de.js",
        cache: undefined
      },
      {
        path: "/var/www/html/i18n/locales/ro/ro.js",
        cache: undefined
      }
    ],
    domains: [
      "my.skillsforwork.de",
      "preprod.my.skillsforwork.de",
      "dev.my.skillsforwork.de",
      "localhost:3000"
    ]
  },
  {
    code: "hu-HU",
    language: "hu-HU",
    name: "Magyar",
    files: [
      {
        path: "/var/www/html/i18n/locales/de/de.js",
        cache: undefined
      },
      {
        path: "/var/www/html/i18n/locales/hu/hu.js",
        cache: undefined
      }
    ],
    domains: [
      "my.skillsforwork.de",
      "preprod.my.skillsforwork.de",
      "dev.my.skillsforwork.de",
      "localhost:3000"
    ]
  },
  {
    code: "de-DE-sfp",
    name: "Deutsch (Produktspezifisch sfp)",
    files: [
      {
        path: "/var/www/html/i18n/locales/de/de.js",
        cache: undefined
      }
    ],
    domains: [
      "my.skillsforwork.de",
      "preprod.my.skillsforwork.de",
      "dev.my.skillsforwork.de",
      "localhost:3000"
    ]
  },
  {
    code: "en-GB-sfp",
    name: "English (Produktspezifisch sfp)",
    files: [
      {
        path: "/var/www/html/i18n/locales/en/en.js",
        cache: undefined
      }
    ],
    domains: [
      "my.skillsforwork.de",
      "preprod.my.skillsforwork.de",
      "dev.my.skillsforwork.de",
      "localhost:3000",
      "my.skillsforwork.com",
      "preprod.my.skillsforwork.com",
      "dev.my.skillsforwork.com"
    ]
  },
  {
    code: "de-DE-lms",
    name: "Deutsch (Produktspezifisch lms)",
    files: [
      {
        path: "/var/www/html/i18n/locales/de/de.js",
        cache: undefined
      }
    ],
    domains: [
      "my.skillsforwork.de",
      "preprod.my.skillsforwork.de",
      "dev.my.skillsforwork.de",
      "localhost:3000"
    ]
  },
  {
    code: "en-GB-lms",
    name: "English (Produktspezifisch lms)",
    files: [
      {
        path: "/var/www/html/i18n/locales/en/en.js",
        cache: undefined
      }
    ],
    domains: [
      "my.skillsforwork.de",
      "preprod.my.skillsforwork.de",
      "dev.my.skillsforwork.de",
      "localhost:3000",
      "my.skillsforwork.com",
      "preprod.my.skillsforwork.com",
      "dev.my.skillsforwork.com"
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/